<template>
  <div class="condition">
    <zg-selector
      v-if="propList.length === 1"
      :store="propList[0].children"
      :width="propWidth"
      keyField="value"
      iconField="icon"
      placeholder="选择属性"
      filterOption
      label-field="label"
      v-model="prop"
      @change="onChangeProp"
    >
      <div
        v-if="haveUserProp"
        slot="optionsHeader"
        class="options-header prop-update-time-tip"
      >
        带＊的属性每日凌晨更新
      </div>
      <template slot-scope="scope">
        <i :class="['c-icon', scope.data.icon]"></i>
        <span>{{ scope.data.label }}</span>
        <span v-if="!scope.data.realTime" class="prop-symbol">{{
          propSymbol
        }}</span>
      </template>
      <slot v-if="prop">
        <span class="c-select-label">
          {{ prop.label
          }}<span class="prop-symbol" v-if="!prop.realTime">{{
            propSymbol
          }}</span>
        </span>
        <i class="c-select-arrow cicon-down"></i>
      </slot>
    </zg-selector>
    <zg-selector
      v-else
      :store="propList"
      :width="propWidth"
      keyField="value"
      children-field="children"
      iconField="icon"
      placeholder="选择属性"
      filterOption
      label-field="label"
      v-model="prop"
      @change="onChangeProp"
    >
      <div
        v-if="haveUserProp"
        slot="optionsHeader"
        class="options-header prop-update-time-tip"
      >
        带＊的属性每日凌晨更新
      </div>
      <template slot-scope="scope">
        <i :class="['c-icon', scope.data.icon]"></i>
        <span>{{ scope.data.label }}</span>
        <span v-if="!scope.data.realTime" class="prop-symbol">{{
          propSymbol
        }}</span>
      </template>
      <slot v-if="prop">
        <span class="c-select-label">
          {{ prop.label
          }}<span class="prop-symbol" v-if="!prop.realTime">{{
            propSymbol
          }}</span>
        </span>
        <i class="c-select-arrow cicon-down"></i>
      </slot>
    </zg-selector>
    <zg-selector
      v-if="prop"
      class="operate-select"
      :store="operateList"
      :width="100"
      v-model="operate"
      keyField="value"
      label-field="name"
      @change="onChangeOperator"
    ></zg-selector>
    <template
      v-if="
        prop &&
          prop.type === 1 &&
          operate.value !== 'is null' &&
          operate.value !== 'is not null'
      "
    >
      <zg-selector
        theme="tag"
        :store="propValues"
        :search="onSearch"
        :width="204"
        :maxWidth="204"
        v-model="propValue"
        @change="onChangePropValue"
        multiple
        key-field="value"
        labelField="label"
      >
        <template slot-scope="scope">
          <span :title="scope.data.label">{{
            strMiddleSplit(scope.data.label)
          }}</span>
        </template>
      </zg-selector>
    </template>
    <template v-else-if="prop && prop.type === 2">
      <zg-input
        v-model="propValue"
        :width="prop.subtype === 2 ? 149 : 204"
        class="number-value"
      ></zg-input>
      <span v-if="prop.subtype === 1">%</span>
      <zg-selector
        v-if="prop.subtype === 2"
        class="prop-subtype"
        :store="propSubtype"
        :width="50"
        v-model="subtype"
        keyField="value"
        label-field="name"
      ></zg-selector>
    </template>
    <template v-else-if="prop && prop.type === 3">
      <zg-input
        v-if="operate.value === 'relative'"
        :width="184"
        v-model="propValue"
        class="number-value"
        placeholder="相对时间"
      ></zg-input>
      <template v-if="operate.value === 'relative'">
        <span>天</span>
        <span style="margin-left: 10px;" v-if="todaySelectable && prop && prop.realTime && propValue !== '0'">
          <c-checkbox v-model="todayDisable">不包含今天</c-checkbox>
        </span>
      </template>
      <el-date-picker
        v-else
        v-model="propValue"
        type="daterange"
        :editable="false"
        :clearable="false"
        range-separator="~"
        start-placeholder="开始日期"
        :picker-options="shortcuts"
        end-placeholder="结束日期"
      >
      </el-date-picker>
    </template>
    <div style="display: none">{{ output }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { actions, getters } from '../../store/constants'
import { util } from '../../utils'

const typeMap = {
  str: 1,
  num: 2,
  date: 3
}
export default {
  name: 'condition',
  props: {
    value: null,
    /**
     * @description 今天可选
     */
    todaySelectable: {
      type: Boolean,
      default: false
    },
    /**
     * @description 如果是事件属性筛选条件，则传事件id
     */
    eventId: {
      type: Number
    },
    /**
     * @description 用户属性
     */
    haveUserProp: {
      type: Boolean,
      default: false
    },
    /**
     * @description 事件环境
     */
    haveEventEnv: {
      type: Boolean,
      default: true
    },
    isOld: {
      type: Boolean,
      default: false
    },
    propWidth: {
      type: Number,
      default: 140
    }
  },
  data() {
    return {
      operate: null,
      prop: null,
      propValue: null,
      todayDisable: false,
      propSymbol: '*',
      propValues: [],
      propSubtype: [
        {
          name: '时',
          value: '1'
        },
        {
          name: '分',
          value: '2'
        },
        {
          name: '秒',
          value: '3'
        }
      ],
      subtype: {
        value: '1'
      },
      shortcuts: {
        disabledDate(time) {
          let end = new Date().setHours(0, 0, 0, 0)
          let current = time.getTime()
          return current > end
        }
      },
      defaultValue: this.value
    }
  },
  computed: {
    ...mapState({
      ready(state) {
        return (
          state.eventEnv.ready.list &&
          state.user.ready.propList &&
          state.eventMeta.ready.list
        )
      },
      currentApp(state) {
        return state.app.currentApp
      },
      event(state) {
        return state.eventMeta.idMap[this.eventId]
      },
      operateList(state) {
        if (this.prop) {
          if(this.prop.id == 31415926){
            return state.common.stringBusinessOperate
          }else if (this.prop.type === typeMap.str) {
            return state.common.stringOperate
          } else if (this.prop.type === typeMap.num) {
            return state.common.numberOperate
          } else if (this.prop.type === typeMap.date) {
            return state.common.dateOperate
          }
        }
        return []
      },
      propList(state) {
        let result = []
        if (this.eventId) {
          // 事件及环境属性
          let event = state.eventMeta.idMap[this.eventId]
          if (event) {
            let eventProp = []
            eventProp = window.eventAttrMap[event.event_id].filter(prop => {
              return !prop.hidden
            })
            result.push({
              id: 0,
              label: '事件属性',
              children: eventProp
            })
          }
        }
        if (this.haveEventEnv) {
          let env = state.eventEnv.list
          result.push({
            id: 1,
            label: '触发环境',
            children: env
          })
        }
        if (this.haveUserProp) {
          // 用户属性
          let userProp = []
          userProp = this.$store.getters[getters.user.getDimensionProp]
          userProp = userProp.filter(prop => {
            return !prop.hidden
          })
          result.push({
            id: 0,
            label: '用户属性',
            children: userProp
          })
        }
        return result
      }
    }),
    output() {
      if (!this.prop) {
        this.$emit('input', undefined)
        this.$emit('change', undefined)
        return undefined
      }
      if (
        !this.operate ||
        !this.propValue ||
        (!this.propValue.length &&
          this.operate &&
          !['is null', 'is not null'].includes(this.operate.value))
      ) {
        this.$emit('input', null)
        this.$emit('change', null)
        return null
      }
      let _typeMap = {
        '1': 'cont-string',
        '2': 'cont-num',
        '3': 'cont-date'
      }
      let condition = {
        attrId: this.prop.id,
        attrName: this.prop.value,
        attrType: _typeMap[this.prop.type],
        category: this.prop.category || 'custom',
        operator: this.operate.value
      }
      if (this.isOld) {
        condition = this.toOld(condition, this.prop)
      }
      switch (this.prop.type) {
        case typeMap.str:
          condition.params = this.propValue.map(item => {
            return item.value
          })
          break
        case typeMap.date:
          if (this.operate.value === 'absolute') {
            condition.params = this.propValue.map(date => {
              return util.dateFormat(date)
            })
          } else {
            let end = this.currentApp.realTime ? '0' : '1'
            if (this.currentApp.realTime) {
              end = this.todayDisable ? '1' : '0'
            }
            condition.params = [this.propValue, end]
          }
          break
        case typeMap.num:
          if (this.prop.subtype === 2) {
            let timeType = {
              '1': 3600,
              '2': 60,
              '3': 1
            }
            let value =
              JSON.parse(this.propValue) * timeType[this.subtype.value]
            condition.params = [value, this.subtype.value]
          } else {
            condition.params = [this.propValue]
          }
          break
      }
      this.$emit('input', condition)
      this.$emit('change', condition)
      return condition
    }
  },
  watch: {
    ready() {
      if (this.ready) {
        this.initData()
      }
    },
    propValue () {
      if (this.propValue === '0') {
        this.todayDisable = false
      }
    }
  },
  beforeCreate() {
    this.$store.dispatch(actions.eventMeta.queryMetas).catch(error => {
      if (error.__CANCEL__) return
      console.error(error)
    })
    this.$store.dispatch(actions.user.queryPropList)
    this.$store.dispatch(actions.eventEnv.query)
  },
  created() {
    if (this.ready) {
      this.initData()
    }
  },
  methods: {
    validate() {
      let result = {
        valid: true,
        errorMsg: ''
      }
      if (!this.prop) {
        result.valid = false
        result.errorMsg = '没有选择属性'
        return result
      }
      if (
        !this.propValue.length &&
        this.operate &&
        !['is null', 'is not null'].includes(this.operate.value)
      ) {
        result.valid = false
        result.errorMsg = '属性值不能为空'
        return result
      }
      // 数值属性值校验：只能是数字
      if (this.prop && this.prop.type === 2 && isNaN(this.propValue)) {
        result.valid = false
        result.errorMsg = '属性值错误'
        return result
      }
      return result
    },
    initData() {
      // 注：因初始赋值需要等待ready状态，导致value会被output覆盖，所以需要defaultValue保存初始值
      if (!this.defaultValue) return
      let prop = null
      this.propList.forEach(item => {
        item.children.forEach(propItem => {
          if (
            this.defaultValue.hasOwnProperty('attrId') &&
            propItem.attr_id === this.defaultValue.attrId
          ) {
            prop = propItem
          } else if (
            propItem.value === this.defaultValue.attrName &&
            propItem.category === this.defaultValue.category
          ) {
            prop = propItem
          }
        })
      })
      if (!prop) return
      this.prop = prop
      let operate = this.defaultValue.operator
      let params = this.defaultValue.params
      this.operate = {
        value: operate
      }
      switch (prop.type) {
        case typeMap.str: {
          let list = params.map(val => {
            return {
              value: val,
              label: val
            }
          })
          this.propValues = list
          this.$nextTick(() => {
            this.propValue = list
          })
          break
        }
        case typeMap.date:
          if (operate === 'absolute') {
            this.propValue = params.map(value => new Date(value))
          } else {
            this.propValue = params[0]
            this.todayDisable = params[1] === '1'
          }
          break
        case typeMap.num:
          if (prop.subtype === 2) {
            let timeType = {
              '1': 3600,
              '2': 60,
              '3': 1
            }
            this.subtype = {
              value: params[1]
            }
            this.propValue = params[0] / timeType[params[1]]
          } else {
            this.propValue = params[0]
          }
          break
        default:
          console.error('未识别的类型', prop)
      }
    },
    strMiddleSplit(str) {
      if (util.isString(str)) {
        return util.strMiddleSplit(str, {
          maxLength: 30,
          beginLength: 28,
          endLength: 0,
          replaceStr: '...'
        })
      }
      return str
    },
    toOld(condition, prop) {
      let oldData = condition
      if (prop.isEventProp) {
        oldData.text = prop.alias_name || prop.attr_name
        oldData.isEventProp = true
        oldData.eventId = this.event.event_id
        oldData.eventName = this.event.event_name
      } else if (prop.isUserProp) {
        oldData.text = prop.alias_name || prop.text
        oldData.isUserProp = true
      } else {
        oldData.text = prop.alias_name || prop.text
      }
      return oldData
    },
    onChangeProp() {
      if (this.prop.type === typeMap.str) {
        this.operate = {
          value: 'equal'
        }
        this.propValue = []
      } else if (this.prop.type === typeMap.num) {
        this.operate = {
          value: '>'
        }
        this.propValue = ''
      } else if (this.prop.type === typeMap.date) {
        this.operate = {
          value: 'relative'
        }
        this.propValue = '30'
      }
    },
    onChangeOperator() {
      if (this.prop.type === typeMap.date) {
        if (this.operate.value === 'absolute') {
          let oneDate = 24 * 60 * 60 * 1000
          let end = new Date(new Date().getTime() - oneDate)
          let start = new Date(end - oneDate * 6)
          this.propValue = [start, end]
        } else {
          this.propValue = '30'
        }
      }
    },
    onChangePropValue() {
      this.onSearch()
    },
    onSearch(val) {
      let param = {
        dimension_sub: this.prop.dimension_sub,
        limit: this.propValue.length + 10,
        attr: this.prop.id,
        v: val || ''
      }
      return new Promise(resolve => {
        this.$store
          .dispatch(actions.common.queryEs, param)
          .then(list => {
            let store = []
            list.forEach(item => {
              store.push({
                label: item,
                value: item
              })
            })
            this.propValues = store
          })
          .finally(() => {
            resolve()
          })
      })
    }
  }
}
</script>

<style lang="sass">
@import "./styles/condition"
</style>
